module.exports = __webpack_public_path__ + "static/media/ciclo.d3f46bd0.png";